// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .op-message-box.op-clear.op-message-box-default-cursor,  */
div[op-panel-type='quality'],
div[op-panel-type='speed'],
div[op-panel-type='audioTrack'] {
  display: none !important;
}

.recording .setting-holder {
  display: none !important;
}

.streamshots_mute .op-progressbar,
.streamshots_mute .op-volume-mute,
.streamshots_mute .op-time-current,
.streamshots_mute .op-time-duration,
.streamshots_mute .op-time-separator,
.streamshots_mute .op-volume-slider-container,
.streamshots_mute .op-volume-max,
.streamshots_mute .op-volume-small {
  display: none !important;
}

.streamshots_mute .op-volume-mute.streamshots {
  display: block !important;
  color: #adadad !important;
}

.OvenPlayer {
  --op-accent-color: #3db9ea;
}

.OvenPlayer--noDVR .op-progressbar {
  display: none;
}

.op-controls .op-con {
  font-size: 15px !important;
}

.op-live-badge,
.op-time-display {
  font-size: 11px !important;
}

.op-time-display {
  margin-top: 5px !important;
}

.op-controls-container .op-bottom-panel .op-progressbar-container {
  bottom: 30px;
}

.op-controls-container .op-bottom-panel .op-controls .op-right-controls {
  padding: 3px 0 4px 0;
  top: -3px;
}

.op-controls-container .op-bottom-panel .op-controls .op-left-controls {
  padding: 3px 0 4px 0;
  top: -3px;
}

.op-setting-panel {
  font-size: 12px;
  bottom: 35px;
}

.op-setting-panel .op-setting-title,
.op-setting-panel .op-setting-item {
  height: 30px;
}

.op-controls-container .op-bottom-panel .op-controls {
  height: 30px;
}

.op-volume-controller .op-volume-slider-container {
  height: 37px;
}

.op-bigbutton-container .op-bigbutton {
  font-size: 50px !important;
}

.op-live-text:not(.custom),
.op-live-badge-lowlatency {
  font-size: 0;
}

.op-live-text.custom {
  cursor: pointer;
}

.context-menu {
  padding: 8px 0;
  display: table;
  width: 100%;
  color: #eee;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.context-menu-item {
  display: table-row;
  cursor: default;
  outline: none;
  height: 40px;
  cursor: pointer;
}

.context-menu-item-icon,
.context-menu-item-label {
  display: table-cell;
  vertical-align: middle;
  padding: 0 15px;
}

.context-menu-item-icon {
  padding: 0 10px;
  text-align: center;
}

.context-menu-item-label {
  padding-left: 0;
}

.context-menu-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/app/components/OvenPlayer/index.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;;;;EAQE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":["/* .op-message-box.op-clear.op-message-box-default-cursor,  */\ndiv[op-panel-type='quality'],\ndiv[op-panel-type='speed'],\ndiv[op-panel-type='audioTrack'] {\n  display: none !important;\n}\n\n.recording .setting-holder {\n  display: none !important;\n}\n\n.streamshots_mute .op-progressbar,\n.streamshots_mute .op-volume-mute,\n.streamshots_mute .op-time-current,\n.streamshots_mute .op-time-duration,\n.streamshots_mute .op-time-separator,\n.streamshots_mute .op-volume-slider-container,\n.streamshots_mute .op-volume-max,\n.streamshots_mute .op-volume-small {\n  display: none !important;\n}\n\n.streamshots_mute .op-volume-mute.streamshots {\n  display: block !important;\n  color: #adadad !important;\n}\n\n.OvenPlayer {\n  --op-accent-color: #3db9ea;\n}\n\n.OvenPlayer--noDVR .op-progressbar {\n  display: none;\n}\n\n.op-controls .op-con {\n  font-size: 15px !important;\n}\n\n.op-live-badge,\n.op-time-display {\n  font-size: 11px !important;\n}\n\n.op-time-display {\n  margin-top: 5px !important;\n}\n\n.op-controls-container .op-bottom-panel .op-progressbar-container {\n  bottom: 30px;\n}\n\n.op-controls-container .op-bottom-panel .op-controls .op-right-controls {\n  padding: 3px 0 4px 0;\n  top: -3px;\n}\n\n.op-controls-container .op-bottom-panel .op-controls .op-left-controls {\n  padding: 3px 0 4px 0;\n  top: -3px;\n}\n\n.op-setting-panel {\n  font-size: 12px;\n  bottom: 35px;\n}\n\n.op-setting-panel .op-setting-title,\n.op-setting-panel .op-setting-item {\n  height: 30px;\n}\n\n.op-controls-container .op-bottom-panel .op-controls {\n  height: 30px;\n}\n\n.op-volume-controller .op-volume-slider-container {\n  height: 37px;\n}\n\n.op-bigbutton-container .op-bigbutton {\n  font-size: 50px !important;\n}\n\n.op-live-text:not(.custom),\n.op-live-badge-lowlatency {\n  font-size: 0;\n}\n\n.op-live-text.custom {\n  cursor: pointer;\n}\n\n.context-menu {\n  padding: 8px 0;\n  display: table;\n  width: 100%;\n  color: #eee;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.context-menu-item {\n  display: table-row;\n  cursor: default;\n  outline: none;\n  height: 40px;\n  cursor: pointer;\n}\n\n.context-menu-item-icon,\n.context-menu-item-label {\n  display: table-cell;\n  vertical-align: middle;\n  padding: 0 15px;\n}\n\n.context-menu-item-icon {\n  padding: 0 10px;\n  text-align: center;\n}\n\n.context-menu-item-label {\n  padding-left: 0;\n}\n\n.context-menu-item:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
